export const SELECT_SYNC_MAPS_CONFIGURATION = "SELECT_SYNC_MAPS_CONFIGURATION"
export const SELECT_MAP_REQUEST_VIEWER_TAB = "SELECT_MAP_REQUEST_VIEWER_TAB"
export const SELECT_NO_MORE_MAP_REQUEST_TO_FETCH = "SELECT_NO_MORE_MAP_REQUEST_TO_FETCH"
export const SELECT_MAP_REQUEST_REFRESH_LENGTH = "SELECT_MAP_REQUEST_REFRESH_LENGTH"
//Configurations
export const ONE_MAP = "ONE_MAP"
export const TWO_MAP = "TWO_MAP"
//Tabs
export const DOCUMENTS = "DOCUMENTS";
export const MAPS = "MAPS";
